export { default } from './SectionDifferences';